export const useReviewData = () => {
  const reviews = [
    {
      id: 1,
      comment: '엔지니어들의 수준이 평균 이상이어서 믿고 같이 일 할 수 있습니다.',
      company: '대형 온라인서점 Y사',
      author: '이** 팀장',
      image: require('@/assets/review_person_01.png')
    },
    {
      id: 2,
      comment: '2주만에 10명의 맞춤 엔지니어를 보내주셔서 플랫폼을 성공적으로 런칭했어요.',
      company: '핀테크 기업 F사',
      author: '전** 본부장',
      image: require('@/assets/review_person_02.png')
    },
    {
      id: 3,
      comment: '프로젝트와 적합한 엔지니어 배치는 물론 자사 일처럼 해주는 점이 맘에 듭니다.',
      company: '배달대행 Y사',
      author: '김** 팀장',
      image: require('@/assets/review_person_03.png')
    },
    {
      id: 4,
      comment: '인원의 유동적인 변경이나 급작스러운 요청에도 빠른 대응을 해 주십니다.',
      company: '금융 어플 T사',
      author: '한** 팀장',
      image: require('@/assets/review_person_04.png')
    },
    {
      id: 5,
      comment: '신규 런칭으로 일정이 촉박했는데, 도메인 경험이 많은 분들이라 Good!',
      company: '이커머스 T사',
      author: '윤** 실장',
      image: require('@/assets/review_person_05.png')
    },
    {
      id: 6,
      comment: '단기 프로젝트를 진행했는데 투입 인원과 아웃풋이 만족스러웠어요.',
      company: '금융 H사',
      author: '강** 차장',
      image: require('@/assets/review_person_06.png')
    }
  ];

  return {
    reviews
  };
};
